// RaphaWelcome — post-registration confirmation.
// Tells the customer to walk to an available station and start their session.

import React from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import Brand from '../components/Brand';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { raphaTheme, colors, shadows } from '../theme';

export default function RaphaWelcome() {
  const { t } = useTranslation('rapha');
  const name = localStorage.getItem('rapha_guest_name') || '';

  return (
    <ThemeProvider theme={raphaTheme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
          px: 2,
          backgroundImage: colors.gradHero,
        }}
      >
        <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box sx={{ position: 'absolute', top: 24, right: 24 }}>
            <LanguageSwitcher />
          </Box>
          <Box sx={{ mb: 5 }}>
            <Brand size="lg" href="/" subtitle="× Rapha" />
          </Box>

          <Box
            sx={{
              width: '100%',
              maxWidth: 440,
              p: { xs: 3, sm: 5 },
              backgroundColor: 'rgba(18, 20, 28, 0.8)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              boxShadow: shadows.xl,
              border: `1px solid ${colors.border}`,
              borderRadius: 3,
              textAlign: 'center',
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 64, color: colors.brand, mb: 2 }} />
            <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
              {t('welcome.title', { name })}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              {t('welcome.subtitle')}
            </Typography>
            <Button
              fullWidth
              variant="contained"
              size="large"
              href="/session"
              sx={{ py: 1.5, fontSize: '1rem' }}
            >
              {t('welcome.goToSession')}
            </Button>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
